import { IconProps } from "../../../utils/global-types/global-types";

const EmailIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
    className={className ? className : "w-4 h-4"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M14.281 2.375H1.72c-.69 0-1.25.56-1.25 1.25v8.75c0 .69.56 1.25 1.25 1.25H14.28c.69 0 1.25-.56 1.25-1.25v-8.75c0-.69-.56-1.25-1.25-1.25"
    ></path>
    <path
      fill="currentColor"
      d="M14.281 1.906H1.72A1.72 1.72 0 0 0 0 3.625v8.75a1.72 1.72 0 0 0 1.719 1.719H14.28A1.72 1.72 0 0 0 16 12.375v-8.75a1.72 1.72 0 0 0-1.719-1.719m.781 10.469a.78.78 0 0 1-.78.781H1.718a.78.78 0 0 1-.782-.781v-8.75a.78.78 0 0 1 .782-.781H14.28a.78.78 0 0 1 .781.781z"
    ></path>
    <path
      fill="#fff"
      d="M13.337 3.88 8.863 7.36a1.406 1.406 0 0 1-1.726 0L2.663 3.88a.469.469 0 1 0-.576.74L6.563 8.1a2.344 2.344 0 0 0 2.878 0l4.472-3.48a.468.468 0 1 0-.576-.74"
    ></path>
  </svg>
);

export default EmailIcon;
